﻿import { getTranslations } from "../translations";
import { sendDataLayer } from "./ecommerce/ecommerce";

declare const intlTelInput: any;

const placeholders = {
    nl: '0612345678',
    fr: '0612345678',
    be: '0470123456',
    de: '015112345678',
    lu: '621123456',
    es: '612345678',
    at: '06641234567',
};

/**
 * formId is only required when you want to be able to disable the submit button
 */
export class phonenumberHolder {
    private input: HTMLInputElement;
    private errorElement: HTMLElement;
    private telCursorStart: number = 0;
    private telCursorEnd: number = 0;
    private formId?: string;
    private required?: boolean = false;
    public iti;
    public error: string | undefined;

    constructor(
        input: HTMLInputElement,
        errorElement: HTMLElement,
        formId?: string,
        required?: boolean,
    ) {
        this.input = input;
        this.errorElement = errorElement;
        this.formId = formId;
        this.required = required;
        this.iti = intlTelInput(input, {
            initialCountry: getTranslations().defaultCountry,
            countryOrder: [getTranslations().defaultCountry],
            onlyCountries: getTranslations().onlyCountries,
            countryNameOverrides: getTranslations().countryNameTranslation,
            placeholderNumberPolicy: "OFF",
            separateDialCode: false,
            countrySearch: false,
            hiddenInputs: () => ({
                phone: "full_phone",
                country: "country_iso2",
            }),
            loadUtils: () => import(`${shopConfig().staticDomain}/js/intlTelInput.util.min.js?v=${shopConfig().versionNumber}`)
        });

        this.iti.promise.then(() => {
            this.initIti();
        })
    };


    private initIti = async () => {
        // To make sure the number is send as full phone number (+31 6 12341234) it must send the hidden inputfield
        // Move attribute and id to hidden field and rename attribute and id for the visible input field
        const idName = $(this.input).attr("id");
        const attrName = $(this.input).attr("name");

        $(this.input).attr("id", "visible_phone");
        $(this.input).attr("name", "visible_phone");
        $(this.input).attr("placeholder", placeholders[this.iti.getSelectedCountry().iso2]);

        $("input[name=\"full_phone\"]").attr("id", idName);
        $("input[name=\"full_phone\"]").val($(this.input).val());
        $("input[name=\"full_phone\"]").attr("name", attrName);

        $(this.input).val(this.iti.getNumber("NATIONAL"));

        // Event listeners
        this.input.addEventListener("input", () => {
            this.errorHandler();
            $(`input[name=\"${attrName}\"]`).val(this.iti.getNumber());
        });


        this.input.addEventListener("change", this.reset);
        this.input.addEventListener("keyup", this.reset);
        this.input.addEventListener("countrychange", this.handleCountryChange);
    }

    private reset = () => {
        // Save the current cursor positions.
        let cursorStart = this.input.selectionStart ?? 0;
        let cursorEnd = this.input.selectionEnd ?? 0;

        const lengthBefore = this.input.value.length;

        // Replace all characters that aren't numbers, spaces, + or -.
        this.input.value = this.input.value.replace(/[^0-9-+ ]/gi, "");

        const lengthAfter = this.input.value.length;

        // Check by how much the input length changed to create an offset for the current cursor positions.
        const lengthChange = lengthAfter - lengthBefore;

        cursorStart += lengthChange;
        cursorEnd += lengthChange;

        if (lengthChange < 0) {
            // If the cursor start position changed, and the end position didn't, the selection direction should be backwards.
            let selectionDirection: "forward" | "backward" | "none" = "forward";
            if (cursorStart !== this.telCursorStart && cursorEnd === this.telCursorEnd)
                selectionDirection = "backward";

            // Ensure the cursor stays on the same position within the text if any characters are stripped out of the input.
            this.input.setSelectionRange(cursorStart, cursorEnd, selectionDirection);
        }

        // Keep track of current cursor selection positions.
        this.telCursorStart = cursorStart;
        this.telCursorEnd = cursorEnd;
    };

    private handleCountryChange = () => {
        $("#phonecountry").val(this.iti.getSelectedCountry()["iso2"]);
        $(this.input).attr("placeholder", placeholders[this.iti.getSelectedCountry().iso2]);
    };

    private enableSubmitButton = () => {
        if (!this.formId) return

        $(`#${this.formId}`).find("button[type=submit]").removeClass("disabled");
    }

    private disableSubmitButton = () => {
        if (!this.formId) return

        $(`#${this.formId}`).find("button[type=submit]").addClass("disabled");
    }

    private errorHandler = () => {
        const errorCode = this.iti.getValidationError();
        const numberType = this.iti.getNumberType();
        const itiValid = this.iti.isValidNumber();
        let errorCodeFailed = false;

        switch (errorCode) {
            case "IS_POSSIBLE_LOCAL_ONLY":
            case "IS_POSSIBLE":
                if (numberType === "UNKNOWN")
                    this.error = getTranslations().phoneValidationError;
                else this.error = undefined;
                break;
            case "TOO_SHORT":
                if ($(this.input).val().length === 0 && !this.required) this.error = undefined;
                else this.error = getTranslations().phoneValidationTooShort;
                break;
            case "TOO_LONG":
                this.error = getTranslations().phoneValidationTooLong;
                break;
            case "INVALID_COUNTRY_CODE":
                this.error = getTranslations().phoneValidationInvalidCountryCode;
                break;
            case "INVALID_LENGTH":
                this.error = getTranslations().phoneValidationError;
                break;
            default:
                this.error = undefined;
                errorCodeFailed = true;
                break;
        }

        if (!itiValid && errorCodeFailed) this.error = getTranslations().phoneValidationError;

        if (this.error) {
            if (this.required) this.disableSubmitButton();

            sendDataLayer({
                "event": "Error",
                "category": "Telefoonnummer",
                "action": document.location.pathname,
                "label": this.error
            });

            this.input.classList.add("field_error");

            if ($(this.input).hasClass("js-validation")) {
                this.input.classList.add("js-validation-failed")
                this.input.classList.remove("js-validation-success")

                $(this.input).parent().addClass("iti--failed");
                $(this.input).parent().removeClass("iti--success");
            }

            this.errorElement.innerHTML = this.error;
            this.errorElement.classList.remove("hidden");

        } else {
            this.input.classList.remove("field_error");
            this.errorElement.classList.add("hidden");

            if ($(this.input).hasClass("js-validation")) {
                this.input.classList.add("js-validation-success")
                this.input.classList.remove("js-validation-failed")

                $(this.input).parent().removeClass("iti--failed");
                $(this.input).parent().addClass("iti--success");
            }

            if (this.required) {
                this.enableSubmitButton();
            }
        }
    }
}
